<template>
  <div class="wrapper">
    <div class="poster-container">
      <div class="poster">
        <div class="canvas-wrapper">
          <img style="width:100%;vertical-align:middle;pointer-events: none;" src="../../assets/images/activity/thanksLetter/share-bg1.png" @load="drawImg()"/>
          <div class="gift-text">
          <!-- <p class="text-indent">{{ clientInfo.clientName }}—— -->
            <div class="text-indent">
              <span class="text-main">感谢您的支持与关爱，祝您在新的一年四通八达，幸福平安！</span>
              <!-- <br> -->
              <div class="text-user">
                <div class="text-line"></div>
                <!-- <div class="text-user-name">{{clientName}}</div> -->
                <div class="text-user-name"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="support">
          <div class="support-count" :style="{'justify-content': $route.name == 'supportPoster' ? 'space-between' : 'center'}">
            <div class="support-number" :style="{'left': $route.name == 'supportPoster' ? '10px' : '0px'}">收到{{supportTotalCount || 0}}赞</div>
            <img v-show="$route.name == 'supportPoster'" @click="handleSupport()" src="../../assets/images/activity/thanksLetter/support.png" />
          </div>
          <div class="alert" v-if="$route.name !== 'supportPoster'">长按保存页面到本地</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { userUtils } from '../../utils/auth'
import activityApi from '../../api/activity.js'
import { commonUtils } from '../../utils/common'
import { sessionStorageUtils } from '../../utils/sessionstorage'
import html2canvas from 'html2canvas'
export default {
  data () {
    return {
      clientInfo: '',
      supportTotalCount: '',
      clientName: '',
      imgUrl: ''
    }
  },
  mounted () {
    this.clientInfo = userUtils.getClientInfo()
    this.clientId = this.$route.query.clientId || this.clientInfo.clientId
    this.clientName = this.$route.query.clientName || this.clientInfo.clientName
    // this.clientName = '北京祥龙博瑞汽车服务（集团）有限公司博瑞陆鼎汽车商行'
    const textDom = document.querySelector('.text-user-name')
    textDom.innerHTML = this.clientName
    this.getSupportCount()
    if (this.$route.name === 'supportPoster') {
      this.initWxJsSdk()
    }
  },
  methods: {
    // 初始化微信jssdk
    initWxJsSdk () {
      console.log('support init wx')
      let sdkUrl = null
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        sdkUrl = global.entryUrl
      }
      const url = document.location.href
      console.log(url)
      const appMessageShare = {
        title: '请收下我的新年祝福', // 分享标题
        desc: '打开祝福为我点赞吧！', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/extra-logo.png', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }

      const timelineShare = {
        title: '请收下我的新年祝福', // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: process.env.VUE_APP_FILE_SERVER + '/static/extra-logo.png', // 分享图标
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils.configWxJsSdk(appMessageShare, timelineShare, sdkUrl).then(() => {
        this.wxReady = true
      }).catch(error => {
        console.log('support error', error)
        this.$emit('error', { errorMsg: error })
      })
    },
    // 点赞
    handleSupport () {
      const wxUserInfo = sessionStorageUtils.get('wxUserInfo') || ''
      if (!wxUserInfo) {
        this.$notify({ type: 'danger', message: '点赞失败！' })
        return false
      }
      const data = {
        targetClientId: this.clientId,
        wxOpenId: wxUserInfo.openId || '',
        wxNickName: wxUserInfo.wxNickName || ''
      }
      console.log(data)
      activityApi.friendSupport(data).then(res => {
        if (res.data.resultCode === '0') {
          console.log(res)
          this.$notify({
            type: 'success',
            message: '点赞成功！'
          })
          this.getSupportCount()
        }
      }).catch(err => {
        console.log(err)
        this.$notify({ type: 'danger', message: '点赞失败！' })
      })
    },

    // 点赞总数
    getSupportCount () {
      const params = {
        targetClientId: this.clientId
      }
      activityApi.supportCount(params).then(res => {
        console.log(res)
        if (res.data.resultCode === '0') {
          this.supportTotalCount = res.data.resultData.supportTotalCount || 0
        }
      }).catch(err => {
        console.log(err)
      })
    },
    DPR () {
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio
      }
      return 1
    },
    drawImg () {
      if (this.$route.name === 'supportPoster' || this.imgUrl) return
      const dom = document.querySelector('.canvas-wrapper')
      // const textDom = document.querySelector('.text-user-name')
      // textDom.innerHTML = this.clientName
      // 创建一个新的canvas
      const canvas = document.createElement('canvas')
      const width = document.body.offsetWidth
      const height = document.body.scrollHeight
      const scaleBy = this.DPR()
      // const scale = window.devicePixelRatio

      canvas.width = width * scaleBy
      canvas.height = height * scaleBy
      html2canvas(dom, {
        canvas: canvas,
        scale: scaleBy,
        // useCORS: true,
        logging: true,
        scrollY: 0
      }).then((canvas) => {
        const context = canvas.getContext('2d')
        // 关闭抗锯齿形
        context.mozImageSmoothingEnabled = false
        context.webkitImageSmoothingEnabled = false
        context.msImageSmoothingEnabled = false
        context.imageSmoothingEnabled = false
        // canvas转化为图片
        const img = document.createElement('img')
        img.src = canvas.toDataURL('image/png') // 可以根据需要更改格式
        this.imgUrl = img.src
        // const img = this.canvas2Image(canvas, canvas.width, canvas.height)
        img.style.cssText = `width:100%;height:${document.body.scrollHeight}px;position:absolute;top:0;left:0;right:0;bottom:0;opacity:0`
        document.body.appendChild(img)
      })
    }
    // canvas2Image (canvas, width, height) {
    //   const retCanvas = document.createElement('canvas')
    //   const retCtx = retCanvas.getContext('2d')
    //   retCanvas.width = width
    //   retCanvas.height = height
    //   retCtx.drawImage(canvas, 0, 0, width, height, 0, 0, width, height)
    //   const img = document.createElement('img')
    //   img.src = retCanvas.toDataURL('image/jpeg') // 可以根据需要更改格式
    //   this.imgUrl = img.src
    //   return img
    // }
  }
}
</script>
<style lang='less' scoped>
@font-face{
    font-family: 'Huawenlishu';
    src : url('../../assets/fonts/huawenlishu.ttf');
}
.wrapper {
  background-color: #1a4146;
  width: 100%;
  height: 100%;
}
.poster-container {
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 667px;
  .poster {
    position: relative;
    .gift-text {
      // display: flex;
      // justify-content: center;
      position: absolute;
      width: 120px;
      height: 320px;
      top: 95px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 30px;
      font-family: "华文隶书", "Huawenlishu", "PingFang SC", "Heiti SC", "Droidsansfallback", "Helvetica", "sans-serif";
      font-size: 18px;
      .text-indent {
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
        width: 100%;
        height: 100%;
        .text-main {
          display: inline-block;
          writing-mode: tb-rl;
        }
        .text-user {
          display: inline-block;
          writing-mode: tb-rl;
          text-indent: 3em;
          position: relative;
          .text-line {
            height: 25px;
            width: 1px;
            background: #000;
            position: absolute;
            top: 25px;
            right: 15px;
          }
          .text-user-name {
            letter-spacing: 5px;
            font-size: 16px;
          }
        }
      }
      div {
        font-size: 18px;
        line-height: 30px;
        letter-spacing: 0.5px;
      }
    }
    .support {
      position: absolute;
      width: 100%;
      height: 75px;
      bottom: 0;
      padding-top: 10px;
      z-index: 2;
      .support-count {
        position: absolute;
        display: flex;
        justify-content: space-between;
        width: 60%;
        height: 39px;
        top: 40%;
        left: 50%;
        transform: translate(-50%,-50%);
        background-image: url('../../assets/images/activity/thanksLetter/count.png');
        background-size: 100% 100%;
        .support-number{
          position: relative;
          width: 60%;
          left: 10px;
          font-size: 18px;
          color: #117281;
          line-height: 39px;
          text-align: center;
          text-shadow: -1px 0  #ffffff, 0 1px #ffffff, 1px 0 #ffffff,0 -1px #ffffff;
          font-family: "华文隶书", "Huawenlishu", "PingFang SC", "Heiti SC", "Droidsansfallback", "Helvetica", "sans-serif";
        }
        img {
          position: absolute;
          width: 35%;
          right: 10px;
          top: -10px;
          animation:move 4s infinite ease-in-out;
        }
        @keyframes move
          {
            0%{
            transform: scale(1);
            }
            25%{
                transform: scale(1.1);
            }
            50%{
                transform: scale(1);
            }
            75%{
                transform: scale(1.1);
            }
          }
      }
      .alert {
        position: absolute;
        bottom: 0;
        width: 100%;
        line-height: 28px;
        color: #fff;
        text-align: center;
        font-family: "华文隶书", "Huawenlishu", "PingFang SC", "Heiti SC", "Droidsansfallback", "Helvetica", "sans-serif";
        &::before {
          content: '';
          background-image: url('../../assets/images/activity/thanksLetter/icon-cloud.png');
          background-size: contain;
          background-repeat: no-repeat;
          width: 50%;
          height: 29px;
          position: absolute;
          top: -4px;
          left: 68px;
        }
        &::after {
          content: '';
          background-image: url('../../assets/images/activity/thanksLetter/icon-cloud.png');
          background-size: contain;
          background-repeat: no-repeat;
          width: 100%;
          height: 29px;
          position: absolute;
          top: -4px;
          left: -70px;
          transform: scaleX(-1);
        }
      }
    }
  }
}
</style>
